import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CanDeactivateGuard } from '@egovsolutions/angular-can-deactivate-guard';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'ppt-contact-bidder',
    template: `
        <div class="content">
            <egov-dialog-close-button [closeHandler]="closeAttempt"></egov-dialog-close-button>
            <div class="content-block bottom-line">
                <h2 mat-dialog-title>Contact Bidder</h2>
                <p> Write a message below for this parcel's Certificate Bidder. We will relay it to the Bidder's email address. </p>
            </div>
            <mat-dialog-content>
                <form [formGroup]="form" (ngSubmit)="submit()">
                    <mat-form-field appearance="standard" hideRequiredMarker class="name">
                        <mat-label>Sender Name</mat-label>
                        <input matInput type="text" formControlName="name" required />
                    </mat-form-field>
                    <mat-form-field appearance="standard" hideRequiredMarker class="email">
                        <mat-label>Sender Email</mat-label>
                        <input matInput type="email" formControlName="email" required email />
                    </mat-form-field>
                    <mat-form-field appearance="outline" hideRequiredMarker class="message">
                        <mat-label>Message</mat-label>
                        <egov-textarea-autoheight>
                            <textarea #textarea matInput formControlName="message" required></textarea>
                        </egov-textarea-autoheight>
                    </mat-form-field>
                    <div class="submit-container">
                        <button mat-flat-button color="primary" class="bigger" type="submit" [disabled]="!form.valid">
                            {{ form.disabled ? "Submitting..." : "Submit" }}
                        </button>
                    </div>
                </form>
            </mat-dialog-content>
        </div>
    `,
    styleUrls: ['./contact-bidder.component.scss'],
})
export class PPTContactBidderComponent
{
    public closeAttempt: () => void;

    protected form: UntypedFormGroup = new UntypedFormGroup({
        name: new UntypedFormControl(''),
        email: new UntypedFormControl(''),
        message: new UntypedFormControl(''),
    });

    constructor
    (
        // private service: PPTCommonService,
        private readonly dialogRef: MatDialogRef<PPTContactBidderComponent>,
        // @Inject(MAT_DIALOG_DATA) private billId: string,
        private readonly canDeactivateGuard: CanDeactivateGuard,
        // private simpleErrorHandling: SimpleErrorHandling,
    )
    {
        this.closeAttempt = this.canDeactivateGuard.addDialog(
            dialogRef,
            () => this.form.value.message?.trim() && 'Discard message for bidder?'
        );
    }

    protected submit()
    {
        this.form.disable();

        // this.service.messageBidder
        // (
        // 	this.billId,
        // 	this.form.get('name')!.value,
        // 	this.form.get('email')!.value,
        // 	this.form.get('message')!.value,
        // )
        // .subscribe(
        // {
        // 	next: () => this.dialogRef.close(true),
        // 	error: error =>
        // 	{
        // 		this.simpleErrorHandling.displayBestErrorMessage(error,
        // 		{
        // 			customMessage: "Error submitting message for bidder.",
        // 			retryHandler: () => this.submit()
        // 		});
        // 		this.form.enable();
        // 	},
        // });
    }
}
